import { observer } from 'mobx-react'
import * as React from 'react'
import styled from 'styled-components'
import { FieldNo } from '../../atoms/FieldNo'
import { HideTablet } from '../../atoms/HideTablet'
import { IntakeStepCol } from '../../atoms/IntakeStepCol'
import { IntakeStepContainer } from '../../atoms/IntakeStepContainer'
import { IntakeStepNoColTablet } from '../../atoms/IntakeStepNoColTablet'
import { Label } from '../../atoms/Label'
import { RadioButton } from '../../atoms/RadioButton'
import { Scale } from '../../atoms/Scale'
import {
  GetOwnIntakeQuery_getOwnIntake, UpdateOwnIntakeMutationVariables,
} from '../../schema/schemaTypes'
import { media } from '../../utils/media'

interface IScaleDefinition {
  from: number,
  fromLabel: string,
  label: string,
  name: string,
  to: 10,
  toLabel: string,
}

interface IProps {
  id: string
  active: boolean
  handleSubmit: (vars: UpdateOwnIntakeMutationVariables) => void
  intake: GetOwnIntakeQuery_getOwnIntake
  isCompleted: boolean
  label: string
  name: string
  no: number
  options?: Array<{ value: any, label: string }>
  scaleIfFalse?: IScaleDefinition
  scaleIfTrue?: IScaleDefinition
}

export const IntakeStepRadioButtonsScale = observer((
  { active, handleSubmit, intake, id, isCompleted, label, name, no, options, scaleIfFalse, scaleIfTrue }: IProps,
) => (
    <IntakeStepContainer id={id} active={active}>
      <IntakeStepNoColTablet>
        <FieldNo checked={isCompleted}>{no}</FieldNo>
      </IntakeStepNoColTablet>
      <IntakeStepCol>
        <div>
          <Label><HideTablet><FieldNo checked={isCompleted}>{no}</FieldNo></HideTablet>{label}</Label>
          {(options || []).map(o => (
            <RadioButton disabled={!active}
              // tslint:disable-next-line:jsx-no-lambda
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const vars = { [name]: o.value }
                if (scaleIfFalse) { vars[scaleIfFalse.name] = null }
                if (scaleIfTrue) { vars[scaleIfTrue.name] = null }
                handleSubmit(vars)
              }}
              id={`intake-${id}-options-${o.value}`} name={`intake-${id}-options`} label={o.label}
              checked={intake[name] === o.value} key={o.value}
            />
          ))}
        </div>
        {intake[name] === true && scaleIfTrue && (
          <div>
            <ScaleLabel>{scaleIfTrue.label}</ScaleLabel>
            <Scale from={scaleIfTrue.from} to={scaleIfTrue.to} fromLabel={scaleIfTrue.fromLabel}
              toLabel={scaleIfTrue.toLabel} disabled={!active} value={intake[scaleIfTrue.name] || null}
              // tslint:disable-next-line:jsx-no-lambda
              onChange={value => handleSubmit({ [scaleIfTrue.name]: value })} />
          </div>
        )}
        {intake[name] === false && scaleIfFalse && (
          <div>
            <ScaleLabel>{scaleIfFalse.label}</ScaleLabel>
            <Scale from={scaleIfFalse.from} to={scaleIfFalse.to} fromLabel={scaleIfFalse.fromLabel}
              toLabel={scaleIfFalse.toLabel} disabled={!active} value={intake[scaleIfFalse.name] || null}
              // tslint:disable-next-line:jsx-no-lambda
              onChange={value => handleSubmit({ [scaleIfFalse.name]: value })} />
          </div>
        )}
      </IntakeStepCol>
    </IntakeStepContainer>
  ))


const ScaleLabel = styled.div`
  margin: 20px 0 16px;
  font-family: Nunito;
  font-size: 16px;
  font-weight: 900;

  ${media.tablet`
    font-size: 20px;
  `}
`



// WEBPACK FOOTER //
// ./src/organisms/Intakes/IntakeStepRadioButtonsScale.tsx